import type { ReactNode } from 'react';
import { WIDGET_MUTED_TEXT_CLASS } from '../constants/widgetTheme';
import SurfaceCard from './SurfaceCard';
import { cn } from './ui/utils';

interface ReportSectionCardProps {
  title: string;
  subtitle?: ReactNode;
  headerRight?: ReactNode;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  children: ReactNode;
}

export default function ReportSectionCard({
  title,
  subtitle,
  headerRight,
  className,
  headerClassName,
  bodyClassName,
  children,
}: ReportSectionCardProps) {
  return (
    <SurfaceCard className={cn('overflow-hidden', className)}>
      <div
        className={cn(
          'flex items-center justify-between gap-3 border-border bg-muted/50 p-4',
          headerClassName,
        )}
      >
        <div>
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          {subtitle ? <div className={cn('text-sm', WIDGET_MUTED_TEXT_CLASS)}>{subtitle}</div> : null}
        </div>
        {headerRight ? <div className={cn('text-sm', WIDGET_MUTED_TEXT_CLASS)}>{headerRight}</div> : null}
      </div>
      <div className={bodyClassName}>{children}</div>
    </SurfaceCard>
  );
}
